import { Dialog, Spinner } from 'construct-ui';
import { v4 as uuidv4 } from 'uuid';
import multipleSelectListComponent from '../../../../components/common/multiple-select-common.component';
import { messageComponent } from '../../../../components/message/message.component';
import paginationComponent from '../../../../components/pagination/pagination.component';
import languageModel from '../../../../models/language.model';
import taskMasterModel from '../../../../models/task-management/task-master.model';
import ViewBase from '../../../view-base.view';
import TaskMasterAddView from './task-master-create.view';
import { exportRetailExcelTemplate } from '../../../../models/file.model'

export default function TaskMasterView() {

  ViewBase.call(this);

  let inputDatModel = {
    taskName: "", permissionList: [], actionTypeList: [], categoryList: [], selectedPermissionList: [], selectedTypes: [], selectedCategories: [], data: [], pageIndex: 1,
    pageSize: 10, totalSize: 0, masterId: 0, statusList: [], selectedStatusList: [], selectedPermission: "", selectedStatus: "", orderBy: "TaskName", sortBy: "ASC",
    orderStatus: { name: 'd', description: 'd', actionType: 'd', permission: 'd', categoryName: "d", status: 'd', createUser: "d", createDate: "d" }
  };
  let userID = 0;
  let isLoading = false;
  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";

  const ddlPermission = {
    selectedValue: ""
  }

  const ddlStatus = {
    selectedValue: ""
  }

  let _getTask = (e) => {
    inputDatModel.taskName = e.target.value;
  }

  let _clearFilter = () => {
    inputDatModel.taskName = "";
    inputDatModel.selectedPermission = "";
    inputDatModel.selectedTypes = [];
    inputDatModel.selectedCategories = []
    inputDatModel.selectedStatus = "";
    inputDatModel.selectedPermissionList = [];
    inputDatModel.selectedStatusList = [];
    _initControls();
  }

  let _search = () => {
    inputDatModel.pageIndex = 1;
    _loadTaskMasterList();
  }

  let _loadTaskMasterList = () => {
    isLoading = true;
    inputDatModel.selectedPermission = inputDatModel.selectedPermissionList.join('^');
    inputDatModel.selectedStatus = inputDatModel.selectedStatusList.join('^');
    taskMasterModel.getTaskMasterList(
      (result) => {
        isLoading = false;
        inputDatModel.data = result.data;
        inputDatModel.totalCount = result.total;
        inputDatModel.pageIndex = result.pageIndex;
        inputDatModel.pageSize = result.pageSize;
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      },
      inputDatModel
    )
  }

  let _loadActionTypeList = () => {
    isLoading = true;
    inputDatModel.actionTypeList = [];
    taskMasterModel.getActionTypeList(
      (result) => {
        isLoading = false;
        result.forEach(function (item) {
          inputDatModel.actionTypeList.push({ code: item.code, name: item.name });
        });
      },
      (error) => {
        isLoading = false;
        this.handleError(error);
      }
    )
  }

  let _initControls = () => {
    _loadActionTypeList();
    _loadTaskCategories();
    _loadTaskMasterList();
    ddlStatus.selectedValue = "";
    ddlPermission.selectedValue = "";
    inputDatModel.permissionList = [{ code: "", name: languageModel.getText("LT00000010", "Choose...") }, { code: "001", name: "Public" }, { code: "002", name: "Personal" }];
    inputDatModel.statusList = [{ code: "", name: languageModel.getText("LT00000010", "Choose...") }, { code: "001", name: "Active" }, { code: "002", name: "Inactive" }];
  }

  const _downloadExcel = () => {
    isLoading = true;
    const fileName = `Task-Master-list-${uuidv4()}.xlsx`;
    const paramsObj = {
      sortBy: "",
      orderBy: "",
      pageIndex: 0,
      pageSize: 0,
      storedProcedureCode: "4",
      params: [
        { code: "20", value: inputDatModel.taskName },
        { code: "21", value: inputDatModel.selectedPermission },
        { code: "22", value: inputDatModel.selectedTypes.join('^') },
        { code: "23", value: inputDatModel.selectedStatus },
        { code: "2", value: "" },
        { code: "24", value: "" },
        { code: "3", value: "0" },
        { code: "4", value: "0" }
      ],
      excelSheetNames: ["Task Master List", "Task Master Count"]
    };
    exportRetailExcelTemplate(paramsObj, fileName).catch((error) => {
      this.handleError(error);
    }).finally(() => {
      isLoading = false;
    })
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDatModel.pageIndex = pageIndex;
    inputDatModel.pageSize = pageSize;
    _loadTaskMasterList();
  }

  let onPageChanged = (pageIndex) => {
    inputDatModel.pageIndex = pageIndex;
    _loadTaskMasterList();
  }

  function _loadDetailsView(item) {
    userID = item.updateUserId;
    inputDatModel.masterId = item.taskMstId;
    isAddViewOpen = true;
  }

  let _registerTaskMaster = () => {
    inputDatModel.masterId = 0;
    isAddViewOpen = true;
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
    if (isRef) {
      isRef = false;
      let ref = getParameterByName("ref");
      if (ref == "task-template") {
        m.route.set("/task-template?ref=task-master");
      }
    }
  }

  let isAddViewOpen = false;

  let _addClose = () => {
    inputDatModel.masterId = 0;
    isAddViewOpen = false;
    let ref = getParameterByName("ref");

    if (ref == "task-template") {
      m.route.set("/task-template?ref=task-master");
    }
  }

  let isRef = false;
  let _onSaveComplete = (result) => {
    inputDatModel.masterId = 0;
    isMsgOpen = true;
    showMsg = result[0].transStatus;
    msgTitle = this.getText(result[0].code, result[0].message);
    _loadTaskMasterList();
    isAddViewOpen = false;
    let ref = getParameterByName("ref");
    if (ref == "task-template") {
      isRef = true;
    }
  }

  let getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function sort(name, id, order) {
    if (order == 'a') {
      inputDatModel.orderStatus[id] = 'd';
      inputDatModel.orderBy = name;
      inputDatModel.sortBy = 'DESC';
      _loadTaskMasterList();
    }
    else {
      inputDatModel.orderStatus[id] = 'a';
      inputDatModel.orderBy = name;
      inputDatModel.sortBy = 'ASC';
      _loadTaskMasterList();
    }
    Object.keys(inputDatModel.orderStatus).forEach(function (key) {
      if (key != id) {
        inputDatModel.orderStatus[key] = 'd';
      }
    });
  }
  let _loadTaskCategories = () => {
    this.showLoading();
    taskMasterModel.getTaskCategories()
      .then(r => {
        if (Array.isArray(r) && r.length > 0) {
          inputDatModel.categoryList = r
        }
      }).catch(e => {
        this.handleError(e)
      }).finally(() => {
        this.hideLoading();
      })
  }

  return {
    oninit: () => {
      _initControls();
    },
    oncreate: () => {
      let ref = getParameterByName("ref");
      if (ref == "task-template") {
        _registerTaskMaster();
      }
    },
    view: () => {
      return [
        m('.row',
          m(Spinner, {
            active: isLoading,
            background: true,
            fill: true,
            size: 'xl',
          }),
          m('.col-12',
            // Title section
            m('.d-flex.justify-content-end.align-items-end.mb-3',
              m('button.btn.btn-outline-primary.btn-add.mb-2',
                { onclick: _registerTaskMaster }, [
                m("i.bi.bi-plus-lg.me-0"),
              ]),
            ),
            // Search section
            m('.card.mb-3',
              m('.card-body',
                m('.row.g-4',
                  m('.col-sm-6.col-lg-3',
                    m('label.form-label', languageModel.getText("LT00000078", "Task Name")),
                    m('input[type=text][placeholder=' + languageModel.getText("LT00000078", "Task Name") + '][value="' + inputDatModel.taskName + '"].form-control.form-control-bg', { onchange: _getTask })
                  ),
                  m('.col-sm-6.col-lg-3', m('label.form-label', this.getText("LT00000079", "Permission")),
                    m(multipleSelectListComponent, {
                      items: inputDatModel.permissionList, selectedList: inputDatModel.selectedPermissionList, handleSelect: (selectedList) => {
                        inputDatModel.selectedPermissionList = selectedList;
                      }
                    })
                  ),
                  m('.col-sm-6.col-lg-3', m('label.form-label', this.getText("LT00000015", "Status")),
                    m(multipleSelectListComponent, {
                      items: inputDatModel.statusList, selectedList: inputDatModel.selectedStatusList, handleSelect: (selectedList) => {
                        inputDatModel.selectedStatusList = selectedList;
                      }
                    })
                  ),
                  m('.col-sm-6.col-lg-3',
                    m('label.form-label', this.getText("LT00000080", "Action Type")),
                    m(multipleSelectListComponent, {
                      items: inputDatModel.actionTypeList, 
                      selectedList: inputDatModel.selectedTypes, 
                      handleSelect: (selectedList) => {
                        inputDatModel.selectedTypes = selectedList;
                      }
                    })
                  ),
                  inputDatModel.categoryList?.length > 1 &&
                  m('.col-sm-6.col-lg-3',
                    m('label.form-label', this.getText("LT00000366", "Category")),
                    m(multipleSelectListComponent, {
                      items: inputDatModel.categoryList,
                      selectedList: inputDatModel.selectedCategories,
                      handleSelect: (selectedList) => {
                        inputDatModel.selectedCategories = selectedList;
                      }
                    })
                  ),
                  m('.col-12.d-flex.justify-content-end.gap-2',
                    m('button.btn.btn-primary', { onclick: _search }, languageModel.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', { onclick: _clearFilter }, languageModel.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),
            // Table section
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.mb-2',
                  m('a.btn.btn-primary', { onclick: _downloadExcel },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), languageModel.getText("LT00000018", "Excel Download"),
                  )
                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table",
                        [
                          m("thead.thead-bggrey",
                            m("tr.align-middle",
                              [
                                m("th.cursor-pointer", { "scope": "col", onclick: (e) => { sort('TaskName', 'name', inputDatModel.orderStatus.name) } }, languageModel.getText("LT00000011", "Name"),
                                  (inputDatModel.orderBy == "TaskName" && inputDatModel.sortBy == "DESC") && m('i.bi.bi-sort-down', { "style": "float:left" }),
                                  (inputDatModel.orderBy == "TaskName" && inputDatModel.sortBy == "ASC") && m('i.bi.bi-sort-up', { "style": "float:left" })
                                ),
                                m("th.cursor-pointer", { "scope": "col", onclick: (e) => { sort('Description', 'description', inputDatModel.orderStatus.description) } }, languageModel.getText("LT00000012", "Description"),
                                  (inputDatModel.orderBy == "Description" && inputDatModel.sortBy == "DESC") && m('i.bi.bi-sort-down', { "style": "float:left" }),
                                  (inputDatModel.orderBy == "Description" && inputDatModel.sortBy == "ASC") && m('i.bi.bi-sort-up', { "style": "float:left" })
                                ),
                                m("th.cursor-pointer", { "scope": "col", onclick: (e) => { sort('ActionTypeName', 'actionType', inputDatModel.orderStatus.actionType) } }, languageModel.getText("LT00000080", "Action Type"),
                                  (inputDatModel.orderBy == "ActionTypeName" && inputDatModel.sortBy == "DESC") && m('i.bi.bi-sort-down', { "style": "float:left" }),
                                  (inputDatModel.orderBy == "ActionTypeName" && inputDatModel.sortBy == "ASC") && m('i.bi.bi-sort-up', { "style": "float:left" })
                                ),
                                m("th.cursor-pointer", { "scope": "col", onclick: (e) => { sort('PermissionName', 'permission', inputDatModel.orderStatus.permission) } }, languageModel.getText("LT00000079", "Permission"),

                                  (inputDatModel.orderBy == "PermissionName" && inputDatModel.sortBy == "DESC") && m('i.bi.bi-sort-down', { "style": "float:left" }),
                                  (inputDatModel.orderBy == "PermissionName" && inputDatModel.sortBy == "ASC") && m('i.bi.bi-sort-up', { "style": "float:left" })
                                ),
                                m("th.cursor-pointer", { "scope": "col", onclick: (e) => { sort('CategoryName', 'status', inputDatModel.orderStatus.categoryName) } }, languageModel.getText("LT00000366", "Category"),
                                  (inputDatModel.orderBy == "StatusName" && inputDatModel.sortBy == "DESC") && m('i.bi.bi-sort-down', { "style": "float:left" }),
                                  (inputDatModel.orderBy == "StatusName" && inputDatModel.sortBy == "ASC") && m('i.bi.bi-sort-up', { "style": "float:left" })
                                ),
                                m("th.cursor-pointer", { "scope": "col", onclick: (e) => { sort('StatusName', 'status', inputDatModel.orderStatus.status) } }, languageModel.getText("LT00000015", "Status"),
                                  (inputDatModel.orderBy == "StatusName" && inputDatModel.sortBy == "DESC") && m('i.bi.bi-sort-down', { "style": "float:left" }),
                                  (inputDatModel.orderBy == "StatusName" && inputDatModel.sortBy == "ASC") && m('i.bi.bi-sort-up', { "style": "float:left" })
                                ),
                                m("th.cursor-pointer", { "scope": "col", onclick: (e) => { sort('UpdateUserId', 'createUser', inputDatModel.orderStatus.createUser) } }, languageModel.getText("LT00000081", "Create User"),
                                  (inputDatModel.orderBy == "UpdateUserId" && inputDatModel.sortBy == "DESC") && m('i.bi.bi-sort-down', { "style": "float:left" }),
                                  (inputDatModel.orderBy == "UpdateUserId" && inputDatModel.sortBy == "ASC") && m('i.bi.bi-sort-up', { "style": "float:left" })
                                ),
                                m("th.cursor-pointer", { "scope": "col", onclick: (e) => { sort('UpdateDate', 'updateUser', inputDatModel.orderStatus.updateUser) } }, languageModel.getText("LT00000041", "Create Date"),
                                  (inputDatModel.orderBy == "UpdateDate" && inputDatModel.sortBy == "DESC") && m('i.bi.bi-sort-down', { "style": "float:left" }),
                                  (inputDatModel.orderBy == "UpdateDate" && inputDatModel.sortBy == "ASC") && m('i.bi.bi-sort-up', { "style": "float:left" })
                                )
                              ])
                          ),
                          m("tbody",
                            inputDatModel.data.length == 0 &&
                            m("tr", { "class": "align-middle" },
                              m("td", { "colspan": "7" }, languageModel.getText("EM00000141", "No records found."))
                            ),
                            inputDatModel.data.map(gc => [
                              m("tr", [
                                m("td.anchorButton", { onclick: () => { _loadDetailsView(gc) } }, gc.taskName),
                                m("td", gc.description),
                                m("td", { "style": "padding-right:55px" }, gc.actionTypeName),
                                m("td", { "style": "width:140px" }, gc.permission.trim() == '001' && m('span.bullet-blue', m('i.bi.bi-circle-fill'), gc.permissionName),
                                  gc.permission.trim() == '002' && m('span.bullet-yellow', m('i.bi.bi-circle-fill'), gc.permissionName)),
                                m("td", { "style": "padding-right:55px" }, gc.categoryName),
                                m("td", gc.status == "001" && m('.badge.rounded-pill.green-bg-status', gc.statusName),
                                  gc.status == "002" && m('.badge.rounded-pill.grey-bg-status', gc.statusName)),
                                m("td", gc.updateUserId),
                                m("td", gc.updateDate)
                              ])
                            ]),
                          )
                        ])
                    ),
                    !isLoading &&
                    m(".px-3",
                      m(paginationComponent, {
                        currentPage: inputDatModel.pageIndex,
                        pageSize: inputDatModel.pageSize,
                        totalItems: inputDatModel.totalCount,
                        onPageChanged: onPageChanged,
                        onPageSizeChanged: onPageSizeChanged
                      })
                    )
                  )
                )
              )
            )
          ),
          isAddViewOpen && m(Dialog, {
            isOpen: isAddViewOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { _addClose() },
            title: inputDatModel.masterId == 0 ? this.getText("LT00000297", "Task Master Create") : this.getText("LT00000298", "Task Master Update"),
            content: m(TaskMasterAddView, { onAddClose: _addClose, onSaveComplete: _onSaveComplete, masterId: inputDatModel.masterId, userID: userID }),
            // "class": "cui-dialog-xxl"
          }),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
        ),
        this.getBaseViews()
      ]
    }
  }
}
